import React, { useEffect, useRef } from "react";
import "../styles/Contact.css";
import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

const Contact: React.FC = () => {
  const mapRefs = useRef<HTMLDivElement[]>([]);
  
  useEffect(() => {
    // Scroll animasyonu için gözlemci oluşturma
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    // Tüm harita containerlarını gözlemle
    mapRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    // DÜZELTME: cleanup için referansı kopyala
    const refs = mapRefs.current;
    return () => {
      refs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  // Harita referanslarını temizleme ve yeniden oluşturma
  const addToRefs = (el: HTMLDivElement | null) => {
    if (el && !mapRefs.current.includes(el)) {
      mapRefs.current.push(el);
    }
  };

  return (
    <div className="contact-container">
      <div className="breadcrumb">ANASAYFA / İLETİŞİM</div>
      <h1 className="contact-title">İLETİŞİM BİLGİSİ</h1>

      {/* Tek widget çerçevesi – sol: bilgi, sağ: harita */}
      <div className="contact-widget" ref={addToRefs}>
        {/* Sol: İletişim Bilgileri */}
        <div className="contact-info-panel">
          <div className="contact-info-header">
            <FaMapMarkerAlt className="contact-icon" />
            <h3>ATS DÖVİZ</h3>
          </div>
          <p className="contact-address">
            Mimar Kemalettin, Ordu Cd. No:63 D:E<br />
            34083 Fatih/İstanbul
          </p>
          <div className="contact-details">
            <span className="contact-detail-item whatsapp-item">
              <FaWhatsapp className="detail-icon whatsapp-icon" />
              +90 (535) 051 98 86
            </span>
            <span className="contact-detail-item">
              <FaPhone className="detail-icon" />
              (0212) 518 50 50 - (0212) 518 24 24
            </span>
            <span className="contact-detail-item">
              <FaEnvelope className="detail-icon" />
              info@atsdoviz.com.tr
            </span>
          </div>
          <div className="address-image-container">
            <img
              src={require("../assets/sube/merkez.png")}
              alt="ATS Döviz Merkez"
              className="address-image"
            />
          </div>
        </div>

        {/* Dikey ayırıcı */}
        <div className="contact-divider" />

        {/* Sağ: Harita */}
        <div className="contact-map-panel">
          <div className="map-panel-header">
            <h3>ATS DÖVİZ</h3>
            <a
              href="https://maps.app.goo.gl/uRtjnTEFEs9A9mWg6"
              target="_blank"
              rel="noopener noreferrer"
              className="directions-button"
            >
              Yol Tarifi Al
            </a>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.7258038519435!2d28.9551706764502!3d41.009374319356716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab98628f442bf%3A0xabec91bca31a8e1b!2sAts%20D%C3%B6viz!5e0!3m2!1str!2str!4v1755082322588!5m2!1str!2str"
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "12px", minHeight: "260px", flex: 1 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="ATS Döviz Harita"
          ></iframe>
        </div>
      </div>

      <div className="icon-bar">
        <a href="mailto:info@atsdoviz.com.tr" className="icon mail" aria-label="E-posta Gönder">
          <FaEnvelope />
        </a>
        <a href="tel:+905350519886" className="icon phone" aria-label="Telefon Et">
          <FaPhone />
        </a>
        <a href="https://wa.me/+905350519886" className="icon whatsapp" aria-label="WhatsApp ile İletişime Geç">
          <FaWhatsapp />
        </a>
      </div>
    </div>
  );
};

export default Contact;